module.exports = __webpack_public_path__ + "img/ws0.408b7233.png";